export default function getSurveyListItems(surveys) {
  const roles = new Map();
  surveys.forEach((survey) => {
    const roleId = survey.role?.id;
    if (!roleId) return;

    const role = roles.get(roleId) ?? {
      id: roleId,
      title: survey.role.title,
      surveys: [],
    };

    role.surveys.push({
      id: survey.id,
      label: survey.campaign.name,
      date: new Date(survey.opened_at).toDateString().toUpperCase(),
    });

    roles.set(roleId, role);
  });

  return roles;
}
